import { motion } from "motion/react"
import { FormattedMessage } from "react-intl";

export default function PageSix() {
    return (
        <motion.div
        className="mainScrollBaseContainer"
        initial={{ opacity: 0, x: 50 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: -50 }}
        transition={{ duration: 0.5 }}
        >
            <div className="centered main heightCenter">
                <div>
                    <div className="featureCard flexible">
                        <h2><FormattedMessage id="multipleLang"/></h2>
                        <ul>
                            <li><FormattedMessage id="de"/></li>
                            <li><FormattedMessage id="en"/></li>
                            <li><FormattedMessage id="es"/></li>
                            <li><FormattedMessage id="fr"/></li>
                            <li><FormattedMessage id="hi"/></li>
                            <li><FormattedMessage id="it"/></li>
                            <li><FormattedMessage id="ja"/></li>
                            <li><FormattedMessage id="ko"/></li>
                            <li><FormattedMessage id="pl"/></li>
                            <li><FormattedMessage id="pt_br"/></li>
                            <li><FormattedMessage id="pt"/></li>
                            <li><FormattedMessage id="ru"/></li>
                            <li><FormattedMessage id="tr"/></li>
                            <li><FormattedMessage id="zh"/></li>
                        </ul>
                    </div>
                    <div className="featureCard flexible">
                        <h3><FormattedMessage id="forTheNerds"/></h3>
                        <ul>
                            <li><FormattedMessage id="elbian"/></li>
                            <li><FormattedMessage id="klingon"/></li>
                        </ul>
                    </div>
                </div>
            </div>
        </motion.div>
    );
}